import AddRFIDTagForm from 'src/components/AuthCode/AddRFIDTagForm';
import { useNavigate } from 'react-router-dom';

export default function AddRFIDTagFormPage() {
  const navigate = useNavigate();

  return (
    <AddRFIDTagForm
      onBack={() => navigate('/tag')}
      onCancel={() => navigate('/tag')}
      onSave={() => navigate('/tag')}
    />
  );
} 